import { Pressable, Text, View, useWindowDimensions } from 'react-native';
import { Bell, Menu } from 'lucide-react-native';

import { colors, typography } from '@/theme/tokens';

interface Props {
  title: string;
  subtitle?: string;
  onMenu?: () => void;
  onNotifications?: () => void;
  unreadAlerts?: number;
  rightContent?: React.ReactNode;
}

export function TopBar({ title, onMenu, onNotifications, unreadAlerts = 0, rightContent }: Props) {
  const { width } = useWindowDimensions();
  const wide = width >= 920;

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingHorizontal: wide ? 28 : 16,
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: colors.ink[100],
        backgroundColor: 'rgba(250, 247, 244, 0.85)',
        // @ts-ignore web only
        backdropFilter: 'blur(12px)',
      }}
    >
      {!wide && onMenu ? (
        <Pressable onPress={onMenu} hitSlop={8} style={{ padding: 6 }}>
          <Menu size={22} color={colors.ink[700]} />
        </Pressable>
      ) : null}

      <Text
        style={{
          flex: 1,
          fontFamily: typography.display.fontFamily,
          fontSize: wide ? 22 : 18,
          fontWeight: typography.weights.bold,
          color: colors.ink[900],
          letterSpacing: -0.2,
        }}
        numberOfLines={1}
      >
        {title}
      </Text>

      {rightContent}

      <Pressable
        onPress={onNotifications}
        hitSlop={8}
        style={({ hovered }) => ({
          width: 38,
          height: 38,
          borderRadius: 12,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: hovered ? colors.magenta[50] : colors.white,
          borderWidth: 1,
          borderColor: colors.ink[100],
          // @ts-ignore web only
          cursor: 'pointer',
        })}
      >
        <Bell size={18} color={colors.ink[700]} />
        {unreadAlerts > 0 ? (
          <View
            style={{
              position: 'absolute',
              top: 5,
              right: 5,
              minWidth: 16,
              height: 16,
              paddingHorizontal: 4,
              borderRadius: 8,
              backgroundColor: colors.danger[500],
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text style={{ color: colors.white, fontSize: 9, fontWeight: typography.weights.bold }}>
              {unreadAlerts > 9 ? '9+' : unreadAlerts}
            </Text>
          </View>
        ) : null}
      </Pressable>
    </View>
  );
}
